import { useQuery } from '@tanstack/react-query';

import { getGuideStatus } from '../api/guide.api';
import { GUIDE_STATUS_QUERY_KEY } from '../constants/guide-query-keys';

const FIVE_MINUTES = 1000 * 60 * 5;

export const useGuideStatus = () => {
  return useQuery({
    queryKey: GUIDE_STATUS_QUERY_KEY,
    queryFn: getGuideStatus,
    staleTime: FIVE_MINUTES,
    refetchOnWindowFocus: true,
  });
};
